module.exports = __webpack_public_path__ + "img/bg_zigezheng@2x.1a54ce15.png";